import { CacheConfig, Network, Variables, RequestParameters, Observable } from 'relay-runtime';
import { BatchFetcher, DEFAULT_BATCHING_CONFIG } from './batchFetcher';
import { shouldTerminateQueriesOnExternalPage } from './externalShare';

const fetchFn = (request: RequestParameters, variables: Variables, cacheConfig: CacheConfig) => {
	const batchFetcher = new BatchFetcher(DEFAULT_BATCHING_CONFIG);
	if (
		!shouldTerminateQueriesOnExternalPage({
			operationName: request.name,
			metadata: cacheConfig.metadata,
		})
	) {
		return batchFetcher.fetch(request, variables, cacheConfig);
	}
	return Observable.create((sink) => {
		sink.complete();
	});
};

export const getNetwork = () => {
	return Network.create(fetchFn);
};

export const getNoopNetwork = () => {
	return Network.create((_request, _variables, _cacheConfig) => {
		return Observable.create((sink) => {
			sink.complete();
		});
	});
};
